import React, { memo, useCallback, useEffect, useRef } from "react";
import { CKEditor } from 'ckeditor4-react';

const CkEditor = ({ value, onChange, placeholder, onBlur }) => {
    const editorRef = useRef(null);

    const config = {
        toolbar: 'basic',
        extraAllowedContent: 'div(*)',
        allowedContent: true,
        height: 500,
        startupFocus: true,
    };

    return (
        <CKEditor 
            initData={value}
            config={config}
            onChange={onChange}
            onBlur={onBlur}
        />
    );
};

export default memo(CkEditor);